import { useEffect, useRef } from "react";

const noop = (_props: any) => {};

/**
 * Wrapper around `ResizeObserver`. `element` must be a reactive `state`, and not `ref.current` in order to keep observer up to date.
 * Wrap all callbacks in `useCallback`
 **/

export const useResizeObserverEffect = (
  element,
  {
    onResize = noop,
    onObserve = noop,
    onUnobserve = noop,
  }: {
    onResize?: (_props: { entries: ResizeObserverEntry[] }) => void;
    onObserve?: (_props: { element: Node }) => void;
    onUnobserve?: (_props: { element: Node }) => void;
  } = {},
): React.MutableRefObject<ResizeObserver> => {
  const resizeObserver = useRef<ResizeObserver>(null);

  useEffect(() => {
    if (!element) return () => {};

    resizeObserver.current = new ResizeObserver((entries) => {
      onResize({
        entries,
      });
    });

    resizeObserver.current.observe(element);

    onObserve({ element });

    return () => {
      resizeObserver.current.unobserve(element);
      resizeObserver.current.disconnect();
      onUnobserve({
        element,
      });
    };
  }, [element, onResize, onObserve, onUnobserve, resizeObserver]);

  return resizeObserver;
};
